import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '隱私政策｜康永生技有限公司',
    description: '康永生技隱私政策：說明本公司如何收集、使用、儲存及保護您的個人資料。適用於本網站所有服務及相關業務往來。',
    keywords: '隱私政策,個人資料保護,康永生技,資料安全',
    lang: 'zh-TW',
    canonicalPath: '/privacy-policy',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="隱私政策｜康永生技有限公司" pageDescription="康永生技隱私政策：說明本公司如何收集、使用、儲存及保護您的個人資料。" pageUrl={`${siteUrl}/privacy-policy`} />
      <div className="min-h-screen bg-white pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/" className="hover:text-gray-600 transition-colors cursor-pointer">首頁</Link>
            <i className="ri-arrow-right-s-line text-base" />
            <span className="text-gray-600">隱私政策</span>
          </nav>

          {/* Header */}
          <div className="mb-10 pb-8 border-b border-gray-100">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">隱私政策</h1>
            <p className="text-gray-400 text-sm">最後更新：2025 年 1 月</p>
          </div>

          {/* Content */}
          <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">一、總則</h2>
              <p className="text-[0.9375rem]">
                康永生技有限公司（以下簡稱「本公司」）重視您的隱私權，並致力於保護您的個人資料。
                本隱私政策說明本公司如何收集、使用、儲存及保護您的個人資料，適用於本網站
                所有服務及相關業務往來。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">二、個人資料的收集</h2>
              <p className="text-[0.9375rem] mb-3">本公司可能收集以下資料：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>姓名、公司名稱、職稱</li>
                <li>聯絡電話及電子郵件地址</li>
                <li>詢問內容與合作需求說明</li>
                <li>網站瀏覽紀錄（Cookie 等技術資訊）</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">三、個人資料的使用目的</h2>
              <p className="text-[0.9375rem] mb-3">本公司收集您的個人資料，僅用於以下目的：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>回覆您的詢問與洽談合作事宜</li>
                <li>提供 ODM / OEM 代工相關報價與資訊</li>
                <li>改善本公司網站與服務品質</li>
                <li>符合法令規定之必要用途</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">四、個人資料的保護</h2>
              <p className="text-[0.9375rem]">
                本公司採取適當的技術與管理措施，保護您的個人資料免受未經授權的存取、
                使用或洩露。您的個人資料僅供本公司內部業務使用，不會出售或出租予第三方，
                亦不會在未經您同意的情況下對外提供，法令另有規定者除外。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">五、Cookie 使用</h2>
              <p className="text-[0.9375rem]">
                本網站使用 Cookie 及類似技術以改善瀏覽體驗。您可透過瀏覽器設定停用 Cookie，
                但部分功能可能因此受到影響。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">六、您的權利</h2>
              <p className="text-[0.9375rem] mb-3">
                依據個人資料保護法，您享有以下權利：
              </p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>查閱或請求複製個人資料</li>
                <li>請求補充或更正個人資料</li>
                <li>請求停止蒐集、處理或利用個人資料</li>
                <li>請求刪除個人資料</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">七、聯絡我們</h2>
              <p className="text-[0.9375rem]">
                如您對本隱私政策有任何疑問，或欲行使上述權利，請透過以下方式聯絡我們：
              </p>
              <div className="mt-4 bg-gray-50 rounded-lg p-5 space-y-2 text-[0.9375rem]">
                <p><strong className="text-gray-900">康永生技有限公司</strong></p>
                <p className="text-gray-600">台中市北區中清路一段79號6樓</p>
                <p>
                  電話：
                  <a href="tel:04-22029858" className="text-[#2d5a27] hover:underline cursor-pointer">(04)-22029858</a>
                </p>
                <p>
                  Email：
                  <a href="mailto:natural1070606@gmail.com" className="text-[#2d5a27] hover:underline cursor-pointer">natural1070606@gmail.com</a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">八、政策修訂</h2>
              <p className="text-[0.9375rem]">
                本公司保留隨時修訂本隱私政策之權利。若有重大變更，將於網站公告通知。
                建議您定期查閱本頁面以了解最新內容。
              </p>
            </section>
          </div>

          {/* Bottom nav */}
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-[#2d5a27] hover:text-[#1a3d18] text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              返回首頁
            </Link>
            <Link
              to="/terms-of-use"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-[#2d5a27] text-sm transition-colors cursor-pointer"
            >
              <i className="ri-file-text-line" />
              查看使用條款
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}